function UserTransaction() {
    "use strict";
    this.__type = 'UserTransaction:www.veritracks.com';
    this.Id = -1;
    //this.Version = 0;

    this.DisplayId = 1;
    this.EnrolleeId = -1;
    this.TypeId = 1;
    this.TransactionStartDate = new Date();
    this.TransactionStopDate = new Date();
    this.TrackPointCount = 0;    
}
if (typeof exports !== 'undefined') {
    module.exports = UserTransaction;
}